import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cc-contact-tags',
  templateUrl: './contact-tags.component.html',
  styleUrls: ['./contact-tags.component.scss']
})
export class ContactTagsComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
